import Nullstack from 'nullstack';
export default function IconCupOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cup-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 8h-3v3h6m4 0h4v-3h-7"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 11l-.323 2.154m-.525 3.497l-.652 4.349h-8l-1.5 -10"
  }), "   ", Nullstack.element("path", {
    d: "M6 8v-1c0 -.296 .064 -.577 .18 -.83m2.82 -1.17h7a2 2 0 0 1 2 2v1"
  }), "   ", Nullstack.element("path", {
    d: "M15 5v-2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}